import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useContent } from "../../lib/ContentContext";

export default function Footer() {
  const { getText } = useContent();
  return (
    <footer className="relative border-t border-white/5 bg-black" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 pt-24 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="tag-glass"><span className="dot" /> India · Est. TalentsOfWorld</div>
            <h2 className="font-display text-5xl md:text-7xl leading-[1.02] tracking-tight text-white mt-6">
              Own the <span className="italic-accent text-grad-crimson">attention</span>.
              <br />
              Not the invoice.
            </h2>
            <Link
              to={getText("footer.cta_url")}
              className="mt-10 btn btn-primary"
              data-testid="footer-cta"
            >
              {getText("footer.cta_label")}
              <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="md:col-span-3">
            <div className="tag-glass mb-6"><span className="dot" /> Explore</div>
            <ul className="space-y-3 text-white/70">
              <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="tag-glass mb-6"><span className="dot" /> Contact</div>
            <p className="text-white/72">{getText("contact.email")}</p>
            <p className="text-white/72 mt-1">{getText("contact.phone")}</p>
            <p className="text-white/50 mt-4 text-sm">
              XMLOOPS · A TalentsOfWorld company. <br />
              {getText("contact.address")}
            </p>
          </div>
        </div>

        <div className="divider-glow my-14" />

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/40 font-mono uppercase tracking-[0.25em]">
          <p>© {new Date().getFullYear()} XMLOOPS. All rights reserved.</p>
          <p>Owned-media × Brand amplification × Integrated ecosystem</p>
        </div>
      </div>

      <div className="pointer-events-none select-none overflow-hidden pb-2">
        <div className="font-display outline-text text-[16vw] md:text-[12vw] leading-[0.9] whitespace-nowrap text-center opacity-70 tracking-tight">
          XMLOOPS
        </div>
      </div>
    </footer>
  );
}
